import styled from "styled-components";

const EditFormIndividualContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export default EditFormIndividualContainer;
